module.exports = __webpack_public_path__ + "static/persona-b973e95cebfeb1e59af8a2218f838598.png";